import { Link } from "react-router-dom";
import LoaderPopup from "../../LoaderAndNotification/LoaderPopup";
import ErrorPopup from "../../LoaderAndNotification/ErrorPopup";

import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { getSelectedLanguage } from "../../../store/Checkin/languageSlice";
import { getAcceptedCards } from "../../../network/apiService";

import { useSelector } from "react-redux";
import { useEffect, useState } from "react";


const PaymentModal = ({
  setPaymentToggle,
  navigateUrl,
  loading2,
  loading3,
  erroModalData2,
  erroModalData3,
  erroModalData4,
  closeErrorModal2,
  closeErrorModal3,
  closeErrorModal4,
  paymentTypeHandler,
  totalAmount,
}) => {
  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);
  const [acceptedCards, setAcceptedCards] = useState({
    creditcard: [],
    debitcard: [],
  });

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
    ;
    const token = localStorage.getItem("token"); // or however you store it
    const fetchCards = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await getAcceptedCards(token);
        console.log("Accepted Cards API Response:", response);
        if (response.data?.result) {
          const cards = response.data.data;
          console.log("Cards Data:", cards);

          const grouped = { creditcard: [], debitcard: [] };

          // First, group them
        cards.forEach((card) => {
          if (card.cardType === "creditcard") grouped.creditcard.push(card);
          else if (card.cardType === "debitcard") grouped.debitcard.push(card);
        });

        // Then, sort each group by SortOrder
        grouped.creditcard.sort((a, b) => a.sortOrder - b.sortOrder);
        grouped.debitcard.sort((a, b) => a.sortOrder - b.sortOrder);

        setAcceptedCards(grouped);
        }
      } catch (error) {
        console.error("Failed to fetch accepted cards", error);
      }
    };

    fetchCards(); // Call the async function
  }, []);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
  }, []);

  return (
    <div className="modal" style={{ zIndex: "1" }}>
      <LoaderPopup loading={loading2} />
      <LoaderPopup loading={loading3} />
      <ErrorPopup
        closeErrorModal={closeErrorModal2}
        erroModalData={erroModalData2}
      />
      <ErrorPopup
        closeErrorModal={closeErrorModal3}
        erroModalData={erroModalData3}
      />

      <ErrorPopup
        closeErrorModal={closeErrorModal4}
        erroModalData={erroModalData4}
      />
      <div className="modal-dialog modal-lg modal-top">
        <div className="modal-content">
          <div className="modal-body">
            <div className="text-center">
              <div>
                <img src="assets/images/person-image.PNG" alt="" />
              </div>
              <div className="mt-30 scan-text">
                <h5 className="cardoptions">{t("Payment Method")}</h5>
              </div>
            </div>
            {/* <div className="text-center mt-30">
              <button
                id="btn-paymentmodal-credit"
                onClick={() => {
                  paymentTypeHandler("creditcard", totalAmount);
                }}
                className="btn modal-no-btn credit-card-btn"
              >
                <i className="bx bx-credit-card-alt payment-card-icon"></i>
                {t("Credit card")}
              </button>
              <button
                id="btn-paymentmodal-debit"
                onClick={() => {
                  paymentTypeHandler("debitcard", totalAmount);
                }}
                className="btn modal-no-btn debit-card-btn"
              >
                <i className="bx bx-credit-card payment-card-icon"></i>Debit
                {t("Card")}
              </button>
             
            </div> */}

            {/* <div className="text-center mt-30 payment-buttons-wrapper">
            
              <div className="payment-option">
                <button
                  id="btn-paymentmodal-credit"
                  onClick={() => paymentTypeHandler("creditcard", totalAmount)}
                  className="btn modal-no-btn credit-card-btn"
                >
                  <i className="bx bx-credit-card-alt payment-card-icon"></i>
                  {t("Credit card")}
                </button>
                <div className="accepted-cards">
                  <img src={visa} alt="Visa" className="card-icon" />
                   <img src={amex} alt="Visa" className="card-icon" />
                    <img src={jcb} alt="Visa" className="card-icon" />
                  <img
                    src={mastercard}
                    alt="MasterCard"
                    className="card-icon"
                  />
                </div>
              </div>

              
              <div className="payment-option">
                <button
                  id="btn-paymentmodal-debit"
                  onClick={() => paymentTypeHandler("debitcard", totalAmount)}
                  className="btn modal-no-btn debit-card-btn"
                >
                  <i className="bx bx-credit-card payment-card-icon"></i>
                  {t("Debit card")}
                </button>
                <div className="accepted-cards">
                  <img src={visa} alt="Visa" className="card-icon" />
                   <img src={amex} alt="Visa" className="card-icon" />
                    <img src={jcb} alt="Visa" className="card-icon" />
                  <img
                    src={mastercard}
                    alt="MasterCard"
                    className="card-icon"
                  />
                </div>
              </div>
            </div> */}
<div className="text-center mt-30 payment-buttons-wrapper">
            <div className="payment-option">
              <button
                id="btn-paymentmodal-credit"
                onClick={() => paymentTypeHandler("creditcard", totalAmount)}
                className="btn modal-no-btn credit-card-btn"
              >
                <i className="bx bx-credit-card-alt payment-card-icon"></i>
                {t("Credit card")}
              </button>
              <div className="accepted-cards">
                {acceptedCards.creditcard.map((card) => (
                  <div key={card.cardId}>
                    <img
                      src={card.imageUrl}
                      alt={card.cardName}
                      className="card-icon"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Debit Card */}
            <div className="payment-option">
              <button
                id="btn-paymentmodal-debit"
                onClick={() => paymentTypeHandler("debitcard", totalAmount)}
                className="btn modal-no-btn debit-card-btn"
              >
                <i className="bx bx-credit-card payment-card-icon"></i>
                {t("Debit card")}
              </button>
              <div className="accepted-cards">
                {acceptedCards.debitcard.map((card) => (
                  <img
                    key={card.cardId}
                    src={card.imageUrl}
                    alt={card.cardName}
                    className="card-icon"
                  />
                ))}
              </div>
            </div>
</div>

          </div>
          <div className="payment-cancel-btn">
            <button
              id="btn-paymentmodal-cancel"
              onClick={() => {
                setPaymentToggle(false);
              }}
              className="btn modal-no-btn credit-card-btn"
            >
              {t("Cancel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;